import axios, { AxiosRequestConfig, AxiosResponse, AxiosError } from 'axios';

import { Configuration, PublicClientApplication } from '@azure/msal-browser'
import { store } from '../redux/store'


const getToken = async (protectedResourcesName: any): Promise<string> => {
  //debugger;

  const sessionConfig = localStorage.getItem("config");
  if (sessionConfig === null) {
    console.log("App settings (msal) are not loaded into the session store yet!");
    return "";
  }

  const appSettings = JSON.parse(sessionConfig);
  const msalConfig = appSettings.msalConfig;

  const protectedResources = appSettings.protectedResources;
  if (protectedResources === null || protectedResources === undefined) {
    console.log("App settings (protected resources) are not loaded into the redux store yet!");
    return "";
  }
  var protectedResourcesServices: any;
  if (protectedResourcesName != "Azure") {
    protectedResourcesServices = protectedResources[protectedResourcesName];
  }


  const pca = new PublicClientApplication(msalConfig);
  const accounts = pca.getAllAccounts();
  const currentAccount = accounts[0];
  const accessTokenRequest = {
    scopes: protectedResourcesName === "Azure" ? ['user.read'] : protectedResourcesServices.scopes,
    account: currentAccount,
  };

  try {
    const resp = await pca.acquireTokenSilent(accessTokenRequest);
    return resp.accessToken;
  } catch (error) {
    // Silent token acquisition failed — fall back to popup
    console.warn("Silent token acquisition failed, falling back to popup", error);
    const resp = await pca.acquireTokenPopup(accessTokenRequest);
    return resp.accessToken;
  }
}

interface ApiResponse<T> {
  data: T;
  status: number;
  statusText: string;
  headers: any;
  config: any;
}


// export function postApiCall<T, R>(url: string, data: T): Promise<R> {
//   return axios.post<T, AxiosResponse<R>>(url, data)
//     .then(response => response.data)
//     .catch((error: AxiosError) => {
//       console.error('Error in POST request:', error);
//       throw error;
//     });
// }
export function postApiCallNoToken<T, R>(url: string, data: T, headers?: Record<string, string>): Promise<R> {
  return axios.post<T, AxiosResponse<R>>(url, data, { headers })
    .then((response: { data: any; }) => response.data)
    .catch((error: AxiosError) => {
      console.error('Error in POST request:', error);
      throw error;
    });
}

export function postApiCall<T, R>(url: string, data: T, protectedResourcesName?: string, headers?: Record<string, string>): Promise<R> {
  return getToken(protectedResourcesName).then(token => {
    //console.log('post', token);
    headers = { 'Authorization': `Bearer ${token}` };
    return axios.post<T, AxiosResponse<R>>(url, data, { headers })
      .then((response: { data: any; }) => response.data)
      .catch((error: AxiosError) => {
        console.error('Error in POST request:', error);
        throw error;
      });
  });
}




export function postDeleteApiCall<T, R>(url: string, headers?: Record<string, string>, protectedResourcesName?: string): Promise<R> {
  return getToken(protectedResourcesName).then(token => {
    //console.log('post', token);
    headers = { 'Authorization': `Bearer ${token}` };
    return axios.post<T, AxiosResponse<R>>(url, { headers })
      .then((response: { data: any; }) => response.data)
      .catch((error: AxiosError) => {
        console.error('Error in POST request:', error);
        throw error;
      });
  });
}

export function putApiCall<T, R>(url: string, data: T): Promise<R> {
  return axios.put<T, AxiosResponse<R>>(url, data)
    .then((response: { data: any; }) => response.data)
    .catch((error: AxiosError) => {
      console.error('Error in PUT request:', error);
      throw error;
    });
}
export function deleteApiCall<T, R>(url: string, data: any, protectedResourcesName?: string): Promise<R> {
  return axios.delete<T, AxiosResponse<R>>(url, data)
    .then((response: { data: any; }) => response.data)
    .catch((error: AxiosError) => {
      console.error('Error in DELETE request:', error);
      throw error;
    });
}

export function getApiCallNoToken<T>(url: string): Promise<T> {
  return axios.get<T>(url)
    .then((response: AxiosResponse<T>) => response.data)
    .catch((error: AxiosError) => {
      console.error('Error in GET request:', error.message);
      throw error;
    });
}
export function getApiCall<T>(url: string, protectedResourcesName?: string): Promise<T> {
  return getToken(protectedResourcesName).then(token => {
    //console.log(token);
    const headers = { headers: { 'Authorization': `Bearer ${token}` } };
    return axios.get<T>(url, headers)
      .then((response: AxiosResponse<T>) => response.data)
      .catch((error: AxiosError) => {
        console.error('Error in GET request:', error.message);
        throw error;
      });
  });
}

export function getDownloadFile<T>(url: string, protectedResourcesName?: string): Promise<T> {
  return getToken(protectedResourcesName).then(token => {
    //console.log(token);
    const headers = { 'Authorization': `Bearer ${token}` } ;
    return axios.get(url,{ headers,  responseType: 'blob'})
      .then((response: AxiosResponse<T>) => response.data)
      .catch((error: AxiosError) => {
        console.error('Error in GET request:', error.message);
        throw error;
      });
  });
}

export function getUserContextFromAzure<T>(url: string): Promise<T> {
  return getToken("Azure").then((token: any) => {
    const headers = { headers: { Authorization: `Bearer ${token}` } };
    return axios
      .get<T>("https://graph.microsoft.com/v1.0/me?$select=mail,displayname,givenName,surname,userPrincipalName,usertype", headers)
      .then((response: AxiosResponse<T>) => response.data)
      .catch((error: AxiosError) => {
        console.error("Error in GET request:", error.message);
        throw error;
      });
  });
}


